/**
 * Set the background image on the page based on the settings provided in an EN code block
 *
 * The code block should be formatted in 4 lines as follows:
 * BACKGROUND IMAGE [this text is always the same]
 * Desktop image URL (no images are shown on mobile)
 * Photo credit e.g. Photo: (c) Independent Age / Photographer Name
 */
export const backgroundImage = () => {
  let foundBackgroundImageSettings = false;

  const codeBlocks = document.querySelectorAll('.en__component--codeblock');

  codeBlocks.forEach((codeBlock) => {
    let codeBlockText = codeBlock.textContent ?? '';

    if (codeBlockText.toLowerCase().includes('[background image]')) {
      foundBackgroundImageSettings = true;

      codeBlockText = codeBlockText
        .replace('[BACKGROUND IMAGE]', '')
        .replace('[Background Image]', '')
        .replace('[background image]', ''); // remove the first line, allowing for mistakes with case
      codeBlockText = codeBlockText.trim().replace(/\r\n/g, ' '); // replace any line breaks with spaces -- NB EN is inconsistent about how it renders code block line breaks
      codeBlockText = codeBlockText.replace(/\s+/g, ' '); // replace multiple spaces with single

      const codeBlockSplitBySpace = codeBlockText.split(' ');
      const backgroundImageDesktop = codeBlockSplitBySpace[0];
      const photoCredit = codeBlockSplitBySpace.slice(1).join(' ').trim();

      const backgroundImageDesktopElement = document.querySelector(
        '.ia-background-image',
      ) as HTMLElement | null;
      const photoCreditElement = document.querySelector(
        '.ia-background-image-credit',
      ) as HTMLElement | null;

      if (backgroundImageDesktopElement) {
        document.body.dataset.iaHasImage = 'true'; // set data attribute so we can check in CSS whether to show the background image elements or not
        backgroundImageDesktopElement.style.backgroundImage = `url('${backgroundImageDesktop}')`;
      }

      if (photoCredit && photoCreditElement) {
        photoCreditElement.textContent = photoCredit;
        photoCreditElement.classList.add('ia-background-image-credit-show'); // show the credit text now that it has been set
      }
    }
  });

  // If not all of document loaded, and we haven't yet found background image settings,
  // then try again (until we find them or page finishes loading with no settings found)
  if (document.readyState !== 'interactive' && !foundBackgroundImageSettings)
    requestAnimationFrame(backgroundImage);
};
